import { format } from 'date-fns';

import { Botao, Chip, Cores, Corpo, Icone } from '@componentes-mu/componentes-mu';

import { Ticket, TicketHistorico } from '../../types/tickets/types';
import Conversation from '../../components/Conversation';
import styles from './styles.module.scss';
import { FlexColumn, FlexRow } from '../../components/Flex';
import { UserDetailsApiResponse } from '../../types/user/types';
import { TicketStatus } from '../../constants/ticketStatus';

export type TicketDetailsProps = {
  ticket: Ticket;
  user: UserDetailsApiResponse
  historicoTickets: TicketHistorico[];
  onGoBack: () => void;
  onSendFeedback: (ticket: Ticket) => void;
  onCreatDirectChannel: () => void;
}

export const TicketDetails = ({ ticket, user, historicoTickets, onGoBack, onSendFeedback, onCreatDirectChannel }: TicketDetailsProps) => {
  const messages = historicoTickets.map(historico => ({
    sender: historico.criadoPor === "MICROUNI" ? user.nomeCliente : historico.criadoPor,
    timestamp: historico.data,
    message: historico.descricao,
    isOwnMessage: historico.oidCriadoPor === "1",
    isClientUser: historico.oidCriadoPor === "1"
  }));

  const statusValue = TicketStatus[ticket.status as unknown as keyof typeof TicketStatus];

  return (
    <div className={styles.ticketDetailsContainer}>

      <FlexColumn className={styles.headerButtons}>
        <FlexRow gap={"1rem"} justifyContent='flex-start'>
          <Botao tipoComportamento="button" onClick={onGoBack} estilo="outlined">
            <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.azulMu} negrito={700}>
              Voltar
            </Corpo>
          </Botao>

          {ticket.referenciaExterna?.trim() != "" && statusValue === TicketStatus["RETORNO"] &&
            <Botao tipoComportamento="button" onClick={() => onSendFeedback(ticket)} estilo="outlined">
              <Corpo tipo="button1" cor={Cores.CoresIdentidadeMU.azulMu} negrito={700}>
                Enviar retorno
              </Corpo>

            </Botao>
          }
        </FlexRow>
      </FlexColumn>

      <div className={styles.ticketInfoCard}>
        <FlexColumn gap={"1rem"}>
          <FlexRow alignContent='space-between' gap={"4rem"}>
            <FlexRow justifyContent='flex-start' gap={"1rem"}>
              <Chip estilo="gray" titulo={ticket.status}></Chip>
              <Chip estado estilo="gray" titulo={ticket.ticket}></Chip>
            </FlexRow>

            <FlexRow justifyContent='flex-end'>
              {user.isClientePremium && user.isMaster &&
                <Botao tipoComportamento="button" onClick={onCreatDirectChannel} estilo="outlined"
                  cor={!user.clientePodeSolicitarCanalDireto ? Cores.GradacaoNeutros.CinzaFillMU100 : Cores.GradacaoPrimaria.AzulMedioMU600}
                  desabilitado={!user.clientePodeSolicitarCanalDireto}
                >
                  <Corpo tipo="button1"
                    cor={!user.clientePodeSolicitarCanalDireto ? Cores.CoresIdentidadeMU.cinzaMu : Cores.CoresIdentidadeMU.brancoMu}
                    negrito={700}>
                    Canal Direto
                  </Corpo>
                  <Icone
                    nome={"notifications"}
                    cor={!user.clientePodeSolicitarCanalDireto ? Cores.CoresIdentidadeMU.cinzaMu : Cores.CoresIdentidadeMU.brancoMu}
                  />
                </Botao>
              }
            </FlexRow>

          </FlexRow>

          <FlexColumn>
            <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>
              Descrição:
            </Corpo>

            <span
              style={{ whiteSpace: 'pre-wrap' }}
              dangerouslySetInnerHTML={{ __html: ticket.titulo }}
            />
          </FlexColumn>

          <FlexRow justifyContent='center' className={styles.ticketInfoCardDetails}>
            <FlexRow justifyContent='flex-start' gap={"1rem"}>
              <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Solicitante:</Corpo>
              <span>{ticket.solicitante}</span>
            </FlexRow>
            <FlexRow justifyContent='flex-start' gap={"1rem"}>
              <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Inclusão:</Corpo>
              <span>{format(new Date(ticket.inclusao), 'dd/MM/yyyy | HH:mm')}</span>
            </FlexRow>
            <FlexRow justifyContent='flex-start' gap={"1rem"}>
              <Corpo tipo="body1" cor={Cores.GradacaoNeutros.CinzaFillMU600} negrito={700}>Versão:</Corpo>
              <span>{ticket.versao}</span>
            </FlexRow>
          </FlexRow>

          <FlexRow justifyContent='flex-start' gap={"1rem"}>
            <Chip estilo="gray" titulo={`Tipo: ${ticket.tipo}`}></Chip>
            <Chip estilo="gray" titulo={`Diagnóstico: ${ticket.diagnostico}`}></Chip>
          </FlexRow>
        </FlexColumn>
      </div>


      <Conversation messages={messages} />
    </div >
  );
}; 